var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32435 18.8328V15.9194C7.32434 15.1784 7.92846 14.5763 8.67696 14.5713H11.4187C12.1708 14.5713 12.7805 15.1749 12.7805 15.9194V15.9194V18.8419C12.7803 19.471 13.2875 19.9853 13.9229 20H15.7507C17.5729 20 19.05 18.5376 19.05 16.7337V16.7337V8.44594C19.0403 7.73629 18.7037 7.06988 18.1361 6.63638L11.8848 1.65104C10.7897 0.782988 9.23289 0.782988 8.13775 1.65104L1.91392 6.64543C1.34415 7.07717 1.00702 7.74468 1 8.45499V16.7337C1 18.5376 2.47713 20 4.29927 20H6.12711C6.77824 20 7.30608 19.4774 7.30608 18.8328V18.8328",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.56cbce0ad85cef42dda5d64f0b94236e.svg";
export { ForwardRef as ReactComponent };